/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CardHeader from '../../components/Heading/CardHeaderExt';
import Card from '../../components/Card/Card';
import CardBody from '../../components/Card/CardBody';
import InputFormRest from '../../components/Form/InputFormRest';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import SelectFromRest from '../../components/Form/SelectFromRest';
import {ServiceUseType, ServiceUseTypeMap, useServiceUseType} from '../../modules/lib/hooks/useOperatorType';
import { configDefault } from '../../core/config';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { platformResellerConstants } from '../../modules/platformreseller/actions';
import { PlatformResellerCollectionInterface } from '../../interfaces/collections/PlatformResellerCollectionInterface';
import { useDispatch } from 'react-redux';
import { SimCardServiceTypeCollection, SimCardServiceTypeItem } from '../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../components/Translate/I18n';
import Filter from '../../interfaces/forms/Filter';
import { FeatureTypes, FeatureVerbType, FeatureVerbTypeMap } from '../../modules/features/FeaturesTypes';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { pricelistSchemaConstants } from '../../modules/pricelists/reducers';
import PricelistSchemaInterface from '../../interfaces/billing/PricelistSchemaInterface';
import ActivateFeatureButton from '../../components/Buttons/ActivateFeatureButton';
import i18n from '../../core/i18n';
import DeactivateFeatureButton from '../../components/Buttons/DeactivateFeatureButton';
import { ComponentParamsDialog } from '../Features/component/ComponentParamsDialog';
import { ComponentParam } from '../Features/component/ComponentByGroup';
import { ServiceTemplateItems } from '../Features/ServiceTemplateEdit';
import { ServiceTempateElementList } from '../Features/ServiceTempateElementList';
import { SimCardServiceTemplate } from '../../interfaces/platform/SimCardServiceTemplate';
import { VirtualComponentSelectedPromotion } from '../VirtualComponent/VirtualComponentSelectedPromotion';
import useResellerAvailableSystemLanguages from "../../modules/language/hooks/useResellerAvailableSystemLanguages";
import useSystemLanguage from "../../modules/language/hooks/useSystemLanguage";
import { SimpleSelectElements } from '../../components/Adescom/SimpleSelect';
import SelectApiList from '../lib/SelectApiList';

interface UssdSmsInterface {
    mainname: string;
    platformResellerId: number;
    ussdCode: string | null;
    smsCode: string | null;
    positiveResponse: string | null;
    negativeResponse: string | null;
    type: number;
    params: string | null;
}

interface UssdSmsEntityInterface {
    mainname: string | null;
    platformResellerId: number | null;
    ussdCode: string | null;
    ussdDeactivateCode: string | null;
    ussdCheckCode: string | null;
    smsCode: string | null;
    smsDeactivateCode: string | null;
    smsCheckCode: string | null;
    positiveResponse: string | null;
    negativeResponse: string | null;
    useType: number | null;
    params: string | null;
    noBalanceResponse: string | null;
    activationCost: number | null;
}

interface ServicesActivationInterface {
    editEntity?: any;
    backToList?: () => void;
}

const _ = require('underscore');

const ServicesActivationForm = (props: ServicesActivationInterface): React.ReactElement => {
    const PLATFORM_RESELLER_URI = '/platform_resellers';

    const dispatch = useDispatch();
    const serviceUseTypes = useServiceUseType();

    const {getResellerLanguagesCallback, resellerAvailableLanguagesCollection} = useResellerAvailableSystemLanguages([{name: 'platformResellerId', value: props.editEntity ? props.editEntity.platformResellerId : -1}])
    const {systemLanguageCollection} = useSystemLanguage();

    const listType = new FeatureTypes(process.env);

    const [wasEdited, setWasEdited] = useState<boolean>(false);
    const [platformResellerList, setPlatformResellerList] = useState<PlatformResellerCollectionInterface | null>(null);
    const [discounts, setDiscounts] = useState<any>({ 'hydra:member': [] });
    const [entity, setEntity] = useState<UssdSmsEntityInterface>(
        props.editEntity
            ? props.editEntity
            : {
                  mainname: null,
                  platformResellerId: null,
                  ussdCode: null,
                  smsCode: null,
                  positiveResponse: null,
                  negativeResponse: null,
                  params: null,
                  useType: null,
              }
    );
    const [definitionComponent, setDefinitionComponent] = useState<SimCardServiceTypeItem | null>(null);
    const [assignedBME, setAssignedBME] = useState<number | null>(null);
    const [assignedSDG, setAssignedSDG] = useState<number | null>(null);
    const [bmeList, setBmeList] = useState<Array<SimCardServiceTypeItem>>([]);
    const [sdgList, setSdgList] = useState<Array<SimCardServiceTypeItem>>([]);
    const [isActivationMode, setIsActivationMode] = useState(true);
    const [verbType, setVerbType] = useState<number | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [templateItems, setTemplateItems] = useState<ServiceTemplateItems>({ components: [] });
    const [discountToActivate, setDiscountToActivate] = useState<number | null>(null);
    const [discountNameToActivate, setDiscountNameToActivate] = useState('');
    const [componentType, setComponentType] = useState<string | null>(null);
    const [filtersProcessedSDG, setFiltersProcessedSDG] = useState<Array<Filter>>([])
    const [filtersProcessedBME, setFiltersProcessedBME] = useState<Array<Filter>>([])

    const loadPlatformResellers = useCallback(
        (uri?: string | null): void => {
            if (!uri) {
                uri = FormGeneralHelper.getPath(PLATFORM_RESELLER_URI, configDefault.PLATFORM_API_PREFIX);
            }

            const loader = new ItemLoaders(dispatch);
            loader.getListWithCallback(
                FormGeneralHelper.getByUri(uri),
                platformResellerConstants.PLATFORM_RESELLER_LIST,
                [{ name: 'itemsPerPage', value: 9999 }],
                [],
                (data: PlatformResellerCollectionInterface) => {
                    setPlatformResellerList(data);
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        },
        [dispatch]
    );


    const loadComponents = useCallback(
        (platformResellerId: number, useType: number): void => {
            setAssignedSDG(null);
            setAssignedBME(null);
            setSdgList([]);
            setBmeList([]);
            const filters: Array<Filter> = [{ name: 'pagination', value: false }];
            listType.operatorType.map((oType) => {
                filters.push({ name: 'operatorType[]', value: oType });
            });
            filters.push({ name: 'platformResellerId', value: platformResellerId });
            filters.push({ name: 'useType', value: `${useType},3` });

            const customSdgFilters = [...filters];
            const customBmeFilters = [...filters];

            customSdgFilters.push({ name: 'serviceType', value: 'SDG' });
            customBmeFilters.push({ name: 'serviceType', value: 'BME' });
            customSdgFilters.push({ name: 'itemsPerPage', value: 20 });
            customBmeFilters.push({ name: 'itemsPerPage', value: 20 });

            setFiltersProcessedSDG(customSdgFilters);
            setFiltersProcessedBME(customBmeFilters);

            const loadItems = new ItemLoaders(dispatch);
            loadItems.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types')),
                'group_load_features_list',
                filters,
                [{ name: 'description', value: 'asc' }],
                (data: SimCardServiceTypeCollection): void => {
                    if (data && data['hydra:member']) {
                        const SDG: Array<SimCardServiceTypeItem> = [];
                        const BME: Array<SimCardServiceTypeItem> = [];

                        data['hydra:member'].map((el: SimCardServiceTypeItem) => {
                            if (el.serviceType === 'BME') {
                                BME.push(el);
                            }

                            if (el.serviceType === 'SDG') {
                                SDG.push(el);
                            }
                        });

                        setBmeList(BME);
                        setSdgList(SDG);
                    }
                },
                { propagateDataToCallback: true, dispatchAfterCallback: false }
            );

            loadItems.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
                platformResellerConstants.PLATFORM_RESELLER_LIST,
                [
                    { name: 'platformResellerId', value: platformResellerId },
                    { name: 'allowUseOnProduct[gt]', value: 0 },
                    { name: 'discountAll', value: 1 },
                    { name: 'active', value: true },
                ],
                [],
                (data: any) => {
                    if (data && data['hydra:member']) {
                        setDiscounts(data);
                    }
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );
        },
        [dispatch, listType]
    );

    const changeInput = (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number): void => {
        // TODO: Add validation (use entityStatus)
        if (!wasEdited) {
            setWasEdited(true);
        }
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const changeInputWithLang = (e: any, stateName: string, type: string, require: boolean, maxValue: number, minValue: number): void => {
        // TODO: Add validation (use entityStatus)
        if (!wasEdited) {
            setWasEdited(true);
        }

        const inputLandPair = stateName.split('_');
        const lang = inputLandPair[1];
        if(inputLandPair[0] === 'positiveResponse') {
            let mess: any = entity.positiveResponse;
            if(!mess) {
                mess = {
                    [lang]: e.target.value
                };
            } else {
                mess = JSON.parse(mess);
                mess[lang] = e.target.value;
            }

            setEntity({ ...entity, positiveResponse: JSON.stringify(mess)});
        }
        if(inputLandPair[0] === 'negativeResponse') {
            let mess: any = entity.negativeResponse;
            if(!mess) {
                mess = {
                    [lang]: e.target.value
                };
            } else {
                mess = JSON.parse(mess);
                mess[lang] = e.target.value;
            }

            setEntity({ ...entity, negativeResponse: JSON.stringify(mess)});
        }
        if(inputLandPair[0] === 'noBalanceResponse') {
            let mess: any = entity.noBalanceResponse;
            if(!mess) {
                mess = {
                    [lang]: e.target.value
                };
            } else {
                mess = JSON.parse(mess);
                mess[lang] = e.target.value;
            }

            setEntity({ ...entity, noBalanceResponse: JSON.stringify(mess)});
        }
    };

    const changeSelect = (e: any, stateName: string, require: boolean): void => {
        if (stateName === 'platformResellerId' && entity.useType !== null) {
            loadComponents(e.target.value, entity.useType);

        }
        if (stateName === 'platformResellerId' ) {
            getResellerLanguagesCallback([{name: 'platformResellerId', value: e.target.value}])
        }
        if (stateName === 'useType' && entity.platformResellerId !== null) {
            loadComponents(entity.platformResellerId, e.target.value);
        }
        if (!wasEdited) {
            setWasEdited(true);
        }
        setEntity({ ...entity, [stateName]: e.target.value });
    };

    const saveElement = (): void => {
        const itemLoaders = new ItemLoaders(dispatch);
        const ent = {
            ...entity,
            params: JSON.stringify({ simCardServiceTemplate: templateItems }),
        };
        if (props.editEntity) {
            itemLoaders.putWithCallback(
                FormGeneralHelper.getByUri(
                    FormGeneralHelper.getPath(`/ussd_sms_communications/${props.editEntity.id}`, configDefault.PLATFORM_API_PREFIX)
                ),
                pricelistSchemaConstants.EDIT,
                ent,
                (data: PricelistSchemaInterface) => {
                    if (props.backToList) {
                        props.backToList();
                    }
                },
                {
                    propagateDataToCallback: true,
                }
            );
        } else {
            itemLoaders.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/ussd_sms_communications', configDefault.PLATFORM_API_PREFIX)),
                pricelistSchemaConstants.ADD,
                ent,
                (data: PricelistSchemaInterface) => {
                    if (props.backToList) {
                        props.backToList();
                    }
                },
                {
                    propagateDataToCallback: true,
                }
            );
        }
    };

    const confirmCallback = (verb: number): void => {
        const groupFeaturesList = [...bmeList, ...sdgList];
        if ((assignedBME || assignedSDG) && groupFeaturesList) {
            for (let i = 0; i < groupFeaturesList.length; i++) {
                if (groupFeaturesList[i].id === assignedBME || groupFeaturesList[i].id === assignedSDG) {
                    setDefinitionComponent(groupFeaturesList[i]);
                    setVerbType(verb);
                    setOpenDialog(true);
                    break;
                }
            }
        }
    };

    const closeCallback = (): void => {
        setOpenDialog(false);
        setDefinitionComponent(null);
        setVerbType(null);
    };

    const addCallbackLocal = (componentParams: ComponentParam): void => {
        addCallback(componentParams);
        closeCallback();
    };

    const addCallback = (componentParams: ComponentParam): void => {
        const newItems = _.clone(templateItems);
        let params: any = [];
        try {
            params = JSON.parse(componentParams.params);
        } catch (e) {
            console.log(e);
        }
        newItems.components.push({
            [componentParams.componentName]: {
                verb: componentParams.status === 1 ? FeatureVerbType.ACTIVATE : FeatureVerbType.DEACTIVATE,
                param: params,
            },
        });
        setTemplateItems(newItems);
    };

    const deleteCallbck = (serviceName: string): void => {
        const newItems: Array<{ [key: string]: { verb: string; param: Array<{ name: string; value: string | number }> } }> = [];
        for (let i = 0; i < templateItems.components.length; i++) {
            const key = Object.keys(templateItems.components[i])[0];
            const values = templateItems.components[i][key];
            if (key !== serviceName) {
                newItems.push({ [key]: values });
            }
        }
        setTemplateItems({ components: newItems });
    };

    const discountSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        if (discounts && discounts['hydra:member']) {
            setDiscountToActivate(parseInt(event.target.value));
            for (let i = 0; i < discounts['hydra:member'].length; i++) {
                if (discounts['hydra:member'][i].id === parseInt(event.target.value)) {
                    setDiscountNameToActivate(discounts['hydra:member'][i].mainname);
                    break;
                }
            }
        }
    };

    const addPromotion = (): void => {
        if (!discountToActivate) {
            return;
        }
        addPromotionCallback({ value: discountToActivate, name: discountNameToActivate });
        setDiscountNameToActivate('');
        setDiscountToActivate(null);
    };

    const addPromotionCallback = (promotion: { value: number; name: string }): void => {
        const newItems = _.clone(templateItems);
        if (!newItems.promotions) {
            newItems.promotions = [];
        }
        newItems.promotions.push(promotion);
        setTemplateItems(newItems);
    };

    const deletePromotionCallback = (promotionId: number): void => {
        const newItems: Array<{ value: number; name: string }> = [];
        if (templateItems.promotions) {
            for (let i = 0; i < templateItems.promotions.length; i++) {
                if (templateItems.promotions[i].value !== promotionId) {
                    newItems.push(templateItems.promotions[i]);
                }
            }
            setTemplateItems({ promotions: newItems, components: templateItems.components });
        }
    };

    const callbackResponseParser = (groupFeaturesList:any): Array<any> => {
        const elementListLocal: Array<SimpleSelectElements> = [];
        if (groupFeaturesList['hydra:member']) {
            console.log(groupFeaturesList)
            groupFeaturesList['hydra:member'].map((item:any) => {
                if (item.simCardServiceTypeParam && item.simCardServiceTypeParam.length > 0) {
                    elementListLocal.push({ value: item.id, name: item.description ?? 'no-name' });
                }
            });
        }
        return elementListLocal;
    }
    useEffect(() => {
        loadPlatformResellers();
    }, [loadPlatformResellers]);

    useEffect(() => {
        if (props.editEntity && !wasEdited) {
            const loader = new ItemLoaders(dispatch);

            const filters: Array<Filter> = [{ name: 'pagination', value: false }];
            listType.operatorType.map((oType) => {
                filters.push({ name: 'operatorType[]', value: oType });
            });
            filters.push({ name: 'platformResellerId', value: props.editEntity.platformResellerId });
            filters.push({ name: 'useType', value: `${props.editEntity.useType},3` });
            const customSdgFilters = [...filters];
            const customBmeFilters = [...filters];

            customSdgFilters.push({ name: 'serviceType', value: 'SDG' });
            customBmeFilters.push({ name: 'serviceType', value: 'BME' });
            customSdgFilters.push({ name: 'itemsPerPage', value: 20 });
            customBmeFilters.push({ name: 'itemsPerPage', value: 20 });

            setFiltersProcessedSDG(customSdgFilters);
            setFiltersProcessedBME(customBmeFilters);

            loader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types')),
                'group_load_features_list',
                filters,
                [{ name: 'description', value: 'asc' }],
                (data: SimCardServiceTypeCollection): void => {
                    if (data && data['hydra:member']) {
                        const SDG: Array<SimCardServiceTypeItem> = [];
                        const BME: Array<SimCardServiceTypeItem> = [];

                        data['hydra:member'].map((el: SimCardServiceTypeItem) => {
                            if (el.serviceType === 'BME') {
                                BME.push(el);
                            }

                            if (el.serviceType === 'SDG') {
                                SDG.push(el);
                            }
                        });

                        setBmeList(BME);
                        setSdgList(SDG);
                    }
                }
            );

            loader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_templates')),
                platformResellerConstants.PLATFORM_RESELLER_LIST,
                [{ name: 'ussdSmsCommunicationId', value: props.editEntity.id }],
                [],
                (data: any) => {
                    if (data && data['hydra:member']) {
                        data['hydra:member'].map((el: SimCardServiceTemplate) => {
                            setTemplateItems(JSON.parse(el.templateItems));
                        });
                    }
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );

            loader.getListWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/discounts')),
                platformResellerConstants.PLATFORM_RESELLER_LIST,
                [
                    { name: 'platformResellerId', value: props.editEntity.platformResellerId },
                    { name: 'allowUseOnProduct[gt]', value: 0 },
                    { name: 'discountAll', value: 1 },
                    { name: 'active', value: true },
                ],
                [],
                (data: any) => {
                    if (data && data['hydra:member']) {
                        setDiscounts(data);
                    }
                },
                {
                    propagateDataToCallback: true,
                    dispatchAfterCallback: false,
                }
            );

            setWasEdited(true);
        }
    }, [dispatch, props.editEntity, loadComponents, listType, wasEdited]);

    return (
        <GridContainer spacing={2}>
            <GridItem xs={12}>
                {props.backToList && (
                    <CustomTextButtom
                        color="primary"
                        label={'services_activation:form.back_to_list'}
                        callback={props.backToList}
                        callbackParam={{}}
                        size={'lg'}
                    />
                )}
            </GridItem>
            <GridItem xs={12}>
                <Card>
                    <CardHeader icon={<AssessmentIcon />} trans="services_activation:form.basic" />
                    <CardBody>
                        <GridContainer spacing={1}>
                            <GridItem xs={4}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'mainname'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.name'}
                                    vMax={256}
                                    vMin={-1}
                                    required={true}
                                    value={entity.mainname}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <SelectFromRest
                                    callback={changeSelect}
                                    required={true}
                                    addEmpty={false}
                                    restElements={{ 'hydra:member': serviceUseTypes ?? [] }}
                                    stateName={'useType'}
                                    stateObjectState={'useType'}
                                    selectedValue={entity.useType}
                                    propKey="value"
                                    propValue="name"
                                    displayEmpty={true}
                                    emptyLabel={'services_activation:form.select_missing'}
                                    label={'services_activation:form.select_type'}
                                />
                            </GridItem>
                            <GridItem xs={4}>
                                <SelectFromRest
                                    callback={changeSelect}
                                    required={true}
                                    addEmpty={false}
                                    restElements={platformResellerList ?? { 'hydra:member': [] }}
                                    stateName={'platformResellerId'}
                                    stateObjectState={'platformResellerId'}
                                    selectedValue={entity.platformResellerId}
                                    propKey="id"
                                    propValue="mainname"
                                    displayEmpty={true}
                                    emptyLabel={'services_activation:h.select_missing'}
                                    label={'services_activation:form.select_partner'}
                                />
                            </GridItem>
                            {(entity.useType === ServiceUseTypeMap.PREPAID || entity.useType === ServiceUseTypeMap.BOTH) ?
                                <GridItem xs={2}>
                                    <InputFormRest
                                        callback={changeInput}
                                        stateName={'activationCost'}
                                        stateObjectState={''}
                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                        displayFieldName={'services_activation:form.activation_cost'}
                                        vMax={256}
                                        vMin={-1}
                                        required={true}
                                        value={entity.activationCost}
                                    />
                                </GridItem> :
                                <GridItem xs={2}></GridItem>
                            }
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'ussdCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.ussd_activate_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.ussdCode}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'ussdDeactivateCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.ussd_deactivate_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.ussdDeactivateCode}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'ussdCheckCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.ussd_check_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.ussdCheckCode}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'smsCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.sms_activate_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.smsCode}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'smsDeactivateCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.sms_deactivate_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.smsDeactivateCode}
                                />
                            </GridItem>
                            <GridItem xs={2}>
                                <InputFormRest
                                    callback={changeInput}
                                    stateName={'smsCheckCode'}
                                    stateObjectState={''}
                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                    displayFieldName={'services_activation:form.sms_check_code'}
                                    vMax={256}
                                    vMin={-1}
                                    required={false}
                                    value={entity.smsCheckCode}
                                />
                            </GridItem>

                            {systemLanguageCollection && resellerAvailableLanguagesCollection && resellerAvailableLanguagesCollection['hydra:member'].map(resellerLang => {
                                let langMnemonic = '';
                                systemLanguageCollection && systemLanguageCollection['hydra:member'].map(el => {
                                    if (el.id === resellerLang.systemLanguageId) {
                                        langMnemonic = el.language
                                    }
                                })

                                return (
                                    <Card key={resellerLang.id} style={{padding: 0}}>
                                        <CardHeader icon={<AssessmentIcon/>}
                                                    trans={'services_activation:form.form_for_lang'}
                                                    additionalContent={<I18n
                                                        trans={`general:language.${langMnemonic}`}/>}
                                        />
                                        <CardBody>
                                            <GridContainer spacing={1}>
                                                <GridItem xs={6}>
                                                    <InputFormRest
                                                        callback={changeInputWithLang}
                                                        stateName={`positiveResponse_${resellerLang.systemLanguageId}`}
                                                        stateObjectState={''}
                                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                                        displayFieldName={'services_activation:form.sms_positive_default_response'}
                                                        vMax={256}
                                                        vMin={-1}
                                                        required={false}
                                                        value={entity.positiveResponse ? JSON.parse(entity.positiveResponse)[resellerLang.systemLanguageId] : entity.positiveResponse}
                                                    />
                                                </GridItem>
                                                <GridItem xs={6}>
                                                    <InputFormRest
                                                        callback={changeInputWithLang}
                                                        stateName={`negativeResponse_${resellerLang.systemLanguageId}`}
                                                        stateObjectState={''}
                                                        typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                        typeField={FormGeneralHelper.TYPE_TEXT}
                                                        displayFieldName={'services_activation:form.sms_negative_response'}
                                                        vMax={256}
                                                        vMin={-1}
                                                        required={false}
                                                        value={entity.negativeResponse ? JSON.parse(entity.negativeResponse)[resellerLang.systemLanguageId] : entity.negativeResponse}
                                                    />
                                                </GridItem>
                                                {(entity.useType === ServiceUseTypeMap.PREPAID || entity.useType === ServiceUseTypeMap.BOTH) &&
                                                    <>
                                                        <GridItem xs={6}>
                                                            <InputFormRest
                                                                callback={changeInputWithLang}
                                                                stateName={`noBalanceResponse_${resellerLang.systemLanguageId}`}
                                                                stateObjectState={''}
                                                                typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                                typeField={FormGeneralHelper.TYPE_TEXT}
                                                                displayFieldName={'services_activation:form.zero_balance_response'}
                                                                vMax={256}
                                                                vMin={-1}
                                                                required={true}
                                                                value={entity.noBalanceResponse ? JSON.parse(entity.noBalanceResponse)[resellerLang.systemLanguageId] : entity.noBalanceResponse}
                                                            />
                                                        </GridItem>
                                                        <GridItem xs={6}></GridItem>
                                                    </>
                                                }
                                            </GridContainer>
                                        </CardBody>
                                    </Card>)
                            })}
                            <GridItem xs={12}>
                                <div style={{ float: 'right' }}>
                                    {(UserRoleHelper.checkRole(roles.ROLE_PLATFORM_USSD_SMS_COMMUNICATION_POST) ||
                                        UserRoleHelper.checkRole(roles.ROLE_PLATFORM_USSD_SMS_COMMUNICATION_PUT)) && (
                                        <CustomTextButtom
                                            color="primary"
                                            label={'services_activation:form.save'}
                                            callback={saveElement}
                                            callbackParam={{}}
                                            size={'lg'}
                                        />
                                    )}
                                </div>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            {(sdgList.length > 0 || bmeList.length > 0) && (
                <GridItem xs={12}>
                    <Card>
                        <CardHeader icon={<AssessmentIcon />} trans="services_activation:form.components" />
                        <CardBody>
                            <GridContainer spacing={1}>
                                <GridItem xs={6}>
                                    {templateItems.components.length > 0 || (templateItems.promotions && templateItems.promotions.length > 0) ? (
                                        <>
                                            <VirtualComponentSelectedPromotion
                                                serviceTemplate={templateItems}
                                                deleteCallback={deletePromotionCallback}
                                            />
                                            <ServiceTempateElementList serviceTemplate={templateItems} deleteCallback={deleteCallbck} />
                                        </>
                                    ) : (
                                        <I18n trans={'services_activation:components:no_assigned_components'} />
                                    )}
                                </GridItem>
                                <GridItem xs={6}>
                                    <GridContainer spacing={0}>
                                        {discounts && discounts['hydra:member'].length > 0 && (
                                            <>
                                                <GridItem xs={10}>
                                                    <SelectFromRest
                                                        callback={discountSelect}
                                                        required={false}
                                                        addEmpty={false}
                                                        restElements={discounts}
                                                        stateName={'platformResellerId'}
                                                        stateObjectState={'platformResellerId'}
                                                        selectedValue={discountToActivate}
                                                        propKey="id"
                                                        propValue="mainname"
                                                        displayEmpty={true}
                                                        emptyLabel={'services_activation:components.discounts'}
                                                        label={'services_activation:components.discounts'}
                                                    />
                                                </GridItem>
                                                <GridItem xs={1} style={{ marginTop: 10, marginLeft: 10 }}>
                                                    <ActivateFeatureButton
                                                        nonTableButton
                                                        callback={addPromotion}
                                                        callbackParam={{}}
                                                        tooltipTitle={i18n.t('prov:features.add_service')}
                                                        size="sm"
                                                    />
                                                </GridItem>
                                            </>
                                        )}
                                        {bmeList.length > 0 && (
                                            <>
                                                <GridItem xs={10}>
                                                    <SelectApiList
                                                        callbackResponseParser={callbackResponseParser}
                                                        optionValue={bmeList}
                                                        addEmpty={true}
                                                        fullWidth={true}
                                                        emptyLabel={i18n.t('services_activation:components.bme_components')}
                                                        filters={filtersProcessedBME}
                                                        orders={[{ name: 'description', value: 'asc' }]}
                                                        iri={FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types'))}
                                                        fieldName={['searchTerm']}
                                                        handleChange={(fieldName, value): void => {
                                                            setAssignedBME(value[0]);

                                                        }}
                                                        useType={1}
                                                    />
                                                </GridItem>
                                                <GridItem xs={1} style={{ marginLeft: 10}}>
                                                    <ActivateFeatureButton
                                                        nonTableButton
                                                        callback={(): void => {
                                                            setIsActivationMode(true);
                                                            confirmCallback(FeatureVerbTypeMap.ACTIVATE);
                                                            setComponentType('BME');
                                                        }}
                                                        callbackParam={{}}
                                                        tooltipTitle={i18n.t('prov:features.add_service')}
                                                        size="sm"
                                                    />
                                                    <DeactivateFeatureButton
                                                        nonTableButton
                                                        callback={(): void => {
                                                            setIsActivationMode(false);
                                                            confirmCallback(FeatureVerbTypeMap.DEACTIVATE);
                                                            setComponentType('BME');
                                                        }}
                                                        callbackParam={{}}
                                                        tooltipTitle={i18n.t('prov:features.delete_service')}
                                                        size="sm"
                                                    />
                                                </GridItem>
                                            </>
                                        )}
                                        {sdgList.length > 0 && (
                                            <>
                                                <GridItem xs={10}>

                                                    <SelectApiList
                                                        callbackResponseParser={callbackResponseParser}
                                                        optionValue={sdgList}
                                                        addEmpty={true}
                                                        fullWidth={true}
                                                        emptyLabel={i18n.t('services_activation:components.sdg_components')}
                                                        filters={filtersProcessedSDG}
                                                        orders={[{ name: 'description', value: 'asc' }]}
                                                        iri={FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_types'))}
                                                        fieldName={['searchTerm']}
                                                        handleChange={(fieldName, value): void => {
                                                            setAssignedSDG(value[0]);

                                                        }}
                                                        useType={1}
                                                    />
                                                </GridItem>
                                                <GridItem xs={1} style={{ marginLeft: 10}}>
                                                    <ActivateFeatureButton
                                                        nonTableButton
                                                        callback={(): void => {
                                                            setIsActivationMode(true);
                                                            confirmCallback(FeatureVerbTypeMap.ACTIVATE);
                                                            setComponentType('SDG');
                                                        }}
                                                        callbackParam={{}}
                                                        tooltipTitle={i18n.t('prov:features.add_service')}
                                                        size="sm"
                                                    />
                                                    <DeactivateFeatureButton
                                                        nonTableButton
                                                        callback={(): void => {
                                                            setIsActivationMode(false);
                                                            confirmCallback(FeatureVerbTypeMap.DEACTIVATE);
                                                            setComponentType('SDG');
                                                        }}
                                                        callbackParam={{}}
                                                        tooltipTitle={i18n.t('prov:features.delete_service')}
                                                        size="sm"
                                                    />
                                                </GridItem>
                                            </>
                                        )}
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            )}
            {definitionComponent && verbType && (
                <ComponentParamsDialog
                    verbType={verbType}
                    open={openDialog}
                    definitionComponent={definitionComponent}
                    closeCallback={closeCallback}
                    confirmCallback={addCallbackLocal}
                    isActivationMode={isActivationMode}
                    typeList={componentType === 'BME' ? bmeList : sdgList}
                    simCardId={-1}
                />
            )}
        </GridContainer>
    );
};

export default ServicesActivationForm;
